import './index.scss';
import { Tag } from 'antd';

export default ({ title }) => (
  <Tag color="warning" className="zorba-app-badge">
    {title}
  </Tag>
);
